import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/NumberAndPlace/NumberAndPlaceLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}


function GetImage(image){
  return '/qimages/' + image+".png";
}


//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

//Checks if string is contained in the answer list
function uniqueItem(value, list) {
  for (var i = 0; i < list.length; i++)
    if (value === list[i].value)
      return false;
  return true;
}

//Runs basic formula up to 6 times while not unique
//Makes a resonable random number if this fails
function uniqueFormula(input, insert, list) {
  var ans = parseFormula(input, insert);
  if (uniqueItem(ans, list))
    return ans;

  for (var i = 0; i < 5; i++) {
    ans = parseFormula(input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }

  var max = parseFloat(list[0].value);
  if (max < 10)
    max = 10;
  for (var i = 0; i < 5; i++) {
    ans = parseFormula("Rand|" + parseFloat(max) / 2 + "|" + max + "|1", input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }
  return ans;
}

//Parses the formula from example question
function parseFormula(input, insert) {
  var newInput = input.replace("$", insert[0]).replace("^", insert[1]);
  if (input.includes("|")) {
    let parts = newInput.split('|');
    if (parts[0] === "Add")
      return parseInt(parts[1]) + parseInt(parts[2]);

    else if (parts[0] === "Sub")
      return parseInt(parts[1]) - parseInt(parts[2]);

    else if (parts[0] === "Seque4")
      return parseInt(parts[1]) + "; " + (parseInt(parts[1]) + parseInt(parts[2])) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 2)) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 3));

    else if (parts[0] === "Rand")
      return Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1]))) * parseInt(parts[3]);

    else if (parts[0] === "Rand2") {
      var answer = Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      var answer2 = Math.round(answer + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      return (answer + "|" + answer2);
    }
    else if (parts[0] === "Char")
      return parts[1].toString()[parts[1].length - parseInt(parts[2])];

    else if (parts[0] === "Round")
      return Math.round(parseInt(parts[1]) / parseInt(parts[2])) * parseInt(parts[2]);

    else if (parts[0] === "RoundUp")
      return Math.ceil(parseInt(parts[1]) / parseInt(parts[2])) * parseInt(parts[2]);

    else if (parts[0] === "RoundDown")
      return Math.floor(parseInt(parts[1]) / parseInt(parts[2])) * parseInt(parts[2]);
  }
  return newInput;
}

//Generates a question from a default question
function GenQuestion(q) {
  //Lookup table for the missing column
  let qKeys = ["Num1Q1", "Num1Q2", "Num3Q1", "Num4Q1", "Num5Q1", "Num6Q1", "Num7Q1", "Num7Q111", "Num8Q1", "Num9Q1", "Num9Q2", "Num11Q1", "Num12Q1", "Num13Q1", "Num14Q1", "Num15Q1", "Num15Q38", "Num15Q112", "Num15Q185", "Num16Q1", "Num16Q123", "Num16Q184", "Num17Q1", "Num17Q2", "Num19Q1", "Num20Q1", "Num21Q1", "Num22Q1", "Num23Q1", "Num24Q1", "Num24Q111", "Num25Q1", "Num25Q111", "Num25Q184", "Num25Q292", "Num26Q1", "Num26Q13", "Num26Q19", "Num26Q24", "Num26Q34", "Num26Q44", "Num26Q53", "Num26Q63", "Num26Q73", "Num26Q83", "Num27Q1", "Num27Q2", "Num28Q1", "Num28Q147", "Num28Q256", "Num29Q1", "Num29Q2", "Num29Q147", "Num29Q148", "Num29Q149", "Num29Q150", "Num29Q151", "Num29Q152", "Num29Q153", "Num29Q154", "Num29Q155", "Num29Q156", "Num29Q239", "Num29Q240", "Num29Q241", "Num29Q242", "Num29Q243", "Num29Q244", "Num29Q245", "Num29Q246", "Num29Q247", "Num29Q248", "Num30Q1", "Num30Q111", "Num30Q184", "Num30Q292", "Num30Q437", "Num30Q546", "Num31Q1", "Num31Q110", "Num32Q1", "Num32Q147", "Num32Q256", "Num32Q363", "Num32Q508", "Num33Q1", "Num33Q2", "Num34Q1", "Num34Q111", "Num34Q184", "Num34Q292", "Num34Q437", "Num34Q546", "Num34Q692", "Num35Q1", "Num35Q147", "Num35Q256", "Num35Q363", "Num35Q508"];
  let generator = ["Rand|11|188|1", "Rand|11|188|1", "Rand|0|30|1", "Rand|0|90|1", "Rand|0|100|1", "Rand|1|15|10", "Rand|10|99|1", "Rand|10|99|1", "Rand|2|20|1", "Rand2|1|100|1", "Rand2|1|100|1", "Rand|0|20|4", "Rand|0|20|8", "Rand|0|12|50", "Rand|0|12|100", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|100|990|1", "Rand|100|990|1", "Rand|100|990|1", "Rand2|100|990|1", "Rand2|100|990|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|870|1", "Rand|200|9870|1", "Rand|2000|98870|1", "Rand|2000|98870|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|10000|97000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand2|1000|9900|1", "Rand2|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand2|100000|990000|1", "Rand2|100000|990000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand|-15|15|1", "Rand|-20|20|1", "Rand|-30|30|1", "Rand|-40|40|1", "Rand|-50|50|1", "Rand|-60|60|1", "Rand|-70|70|1", "Rand|-80|80|1", "Rand|-90|90|1", "Rand|-100|100|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|10000|97000|1", "Rand|10000|97000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand2|1000000|9900000|1", "Rand2|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1"];
  console.log(q);

  var imageString = "";
  var qhtml = "";

  if (q.topic_key == "num48"){//3 digit number from a sum
    let hundreds = GenerateRandom(1,9);
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);
    var correctAnswer = hundreds*100 + tens*10 + ones;
    questionText= hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(100,999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  }
  else if (q.topic_key == "newnum1"){//count backwards below 10
    let num1 = GenerateRandom(6,10);
    let num2 = GenerateRandom(1,5);
    var correctAnswer = num1-num2;

    questionText= "Start at " + num1 + " and count back " + num2;
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1,9,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  }
  else if (q.topic_key == "newnum2"){//biggest number
    let num1 = GenerateRandom(5,20);

    var correctAnswer = num1;
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1,num1-1,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

    shuffleArray(usedAnswers);

    questionText= "Which is the biggest number? "+ usedAnswers[0] + ", " + usedAnswers[1] + ", " + usedAnswers[2] + ", " + usedAnswers[3];
  }
  else if (q.topic_key == "newnum3"){//smallest number
    let num1 = GenerateRandom(5,20);

    var correctAnswer = num1;
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(num1,20,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

    shuffleArray(usedAnswers);

    questionText= "Which is the smallest number? "+ usedAnswers[0] + ", " + usedAnswers[1] + ", " + usedAnswers[2] + ", " + usedAnswers[3];
  }
  else if (q.topic_key == "newnum4"){//number line
    let num1 = GenerateRandom(1,9);

    var correctAnswer = num1;
    questionText= "Which number is missing from the number line?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1,9,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

    shuffleArray(usedAnswers);

    qhtml = '<img src="' + GetImage("numberlineblank") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

    var rightPos = 86.6;
    var column = 1;
    var topPos = 20;
    var rightModifier = 9.45;

    for (let x = 1; x < 10; x++) {
      //swaps columns

      if (x == num1){
        qhtml += '<div '+ "style='position:absolute ; color: red; font-weight: bold; font-size: 3.5em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>?</div>'
      }else{
        qhtml += '<div '+ "style='position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>'+x+'</div>'
      }
        rightPos -= rightModifier;
    }

    
  }

  else if (q.topic_key == "newnum6"){ //ten frame 1-10
    let num1 = GenerateRandom(1,10);

    var correctAnswer = num1;
    questionText= "What number is represented in the ten frame?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1,10,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

      qhtml = '<img src="' + GetImage("tenframetable") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPos = 70.5;
      var column = 1;
      var topPosTop = -25;
      var topPosBottom = 25;
      var rightModifier = 20;

      qhtml+= "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2){
          topPos = topPosBottom;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'

        if (column == 1){
          rightPos -= rightModifier;
        }
      }
      qhtml+="</div>";
  }
  else if (q.topic_key == "newnum5"){ //how many rockets
    let num1 = GenerateRandom(1,10);

    var correctAnswer = num1;
    questionText= "How many rockets?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1,10,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

      //then loop through tens
      var rightPos = 70.5;
      var column = 1;
      var topPosTop = -25;
      var topPosBottom = 25;
      var rightModifier = 20;

      qhtml = '<img src="' + GetImage("blank") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      qhtml += "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2){
          topPos = topPosBottom;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("rocket") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.4,0.4);  zIndex:-1'" + '></img>'

        if (column == 1){
          rightPos -= rightModifier;
        }
      }
      qhtml+="</div>";
  }

  else if (q.topic_key == "num58"){//10-99 missing part whole model
    let num1 = GenerateRandom(10,49);
    let num2 = GenerateRandom(10,49);
    let num3 = num1+num2;
    let correctAnswer = num2;

    questionText= "What number is missing from the part-whole model?";

    qhtml = "<div>";
    qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:47%'>" + num3 + "</b>";
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + num1 + "</b>"
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + "?" + "</b>"
    qhtml+= "</div>"
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(10,49,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  }
  else if (q.topic_key == "num57"){//10-99 missing part whole model
    let num1 = GenerateRandom(10,49);
    let num2 = GenerateRandom(10,49);
    var correctAnswer = num1+num2;
    questionText= "What number is missing from the part-whole model?";

    qhtml = "<div>";
    qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + "?" + "</b>";
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + num1 + "</b>"
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:16%'>" + num2 + "</b>"
    qhtml+= "</div>"
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(10,99,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  }
  else if (q.topic_key == "num53"){//100-999 base ten blocks
    let hundreds = GenerateRandom(1,9);
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);
    var correctAnswer = hundreds*100 + tens*10 + ones;
    questionText= "What number is represented by the base ten blocks?";

    qhtml = "<div>";
    qhtml+= '<img src="' + GetImage("100cube"+hundreds) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= '<img src="' + GetImage("10cube"+tens) + '"' + "style='position:relative ; right:-5%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= '<img src="' + GetImage("1cube"+ones) + '"' + "style='position:relative ; right:-10%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= "</div>"
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(100,999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  }
  else if (q.topic_key == "num49"){//1000-9999 base ten blocks
    let thousands = GenerateRandom(1,6);
    let hundreds = GenerateRandom(1,9);
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);
    var correctAnswer = thousands * 1000 + hundreds*100 + tens*10 + ones;
    questionText= "What number is represented by the base ten blocks?";

    qhtml = "<div>";
    qhtml+= '<img src="' + GetImage("1000cube"+thousands) + '"' + "style='position:relative ; right:14% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= '<img src="' + GetImage("100cube"+hundreds) + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= '<img src="' + GetImage("10cube"+tens) + '"' + "style='position:relative ; right:-5%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= '<img src="' + GetImage("1cube"+ones) + '"' + "style='position:relative ; right:-10%% ; zIndex:-1;transform: scale(1.5,1.5)'" + '></img>';
    qhtml+= "</div>"
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1000,6999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  }
  else if (q.topic_key == "num8"){//numberline
    let line = GenerateRandom(1,19);
    var correctAnswer = line;
    questionText= "What number is shown on the number line?";
    imageString= "numberline"+line;

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1,19,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
    
  }
  else if (q.topic_key == "num61"){ //ten frame
    let num1 = GenerateRandom(1,9);
    let num2 = GenerateRandom(1,9);

    var correctAnswer = num1 + num2;
    questionText= "What number is represented in the ten frame?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(2,20,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

      qhtml = '<img src="' + GetImage("tenframetablequestion") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPos = 84.5;
      var column = 1;
      var topPosTop = 4;
      var topPosBottom = 28;
      var rightModifier = 7;

      qhtml+= "<div>";
      for (let x = 0; x < num1; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2){
          topPos = topPosBottom;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'

        if (column == 1){
          rightPos -= rightModifier;
        }
      }
      qhtml+="</div>";
      //loop through ones
      var rightPos = 37.8;
      var column = 1;
      var topPosTop = 4;
      var topPosBottom = 28;
      var rightModifier = 7;

      qhtml+= "<div>";
      for (let x = 0; x < num2; x++) {
        //swaps columns
        let topPos = topPosTop;
        if (column == 2){
          topPos = topPosBottom;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("tenframecounter") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.3,0.3);  zIndex:-1'" + '></img>'

        if (column == 1){
          rightPos -= rightModifier;
        }
      }
      qhtml+="</div>";
  }
  else if (q.topic_key == "num60"){ //place value grid 1-99
    let tens = GenerateRandom(1,8);
    let ones = GenerateRandom(1,8);

    var correctAnswer = tens*10 + ones;
    questionText= "What number is shown on in the place value grid?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(10,99,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

      qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPosLeft = 75;
      var rightPosRight = 55;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //loop through ones
      var rightPosLeft = 25;
      var rightPosRight = 5;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
  }
  else if (q.topic_key == "num55"){ //place value grid 1-99 ODD OR EVEN
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);

    var num1 = tens*10 + ones;
    
    var questionText = "Is the number " + num1 + " odd or even?";
   
    var questionAnswers = [];
    if (num1 % 2 == 0){//even
      var correctAnswer = "Even";
      questionAnswers.push({ correct: true, value: "Even" });
    questionAnswers.push({ correct: false, value: "Odd"});
    }else{//odd
      var correctAnswer = "Odd";
      questionAnswers.push({ correct: true, value: "Odd" });
    questionAnswers.push({ correct: false, value: "Even"});
    }

      qhtml = '<img src="' + GetImage("placetabletensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';
      //then loop through tens
      var rightPosLeft = 75;
      var rightPosRight = 55;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //loop through ones
      var rightPosLeft = 25;
      var rightPosRight = 5;
      var column = 1;
      var topPos = 10;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
  }

  else if (q.topic_key == "num40"){ //place value grid 100-999
    let hundreds = GenerateRandom(1,9);
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);

    var correctAnswer = hundreds * 100 + tens*10 + ones;
    questionText= "What number is shown on in the place value grid?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(100,999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

      qhtml = '<img src="' + GetImage("placetablehundredstensones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      //then loop through hundreds
      var rightPosLeft = 83;
      var rightPosRight = 68;
      var column = 1;
      var topPos = 15;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < hundreds; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("100token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      //then loop through tens
      var rightPosLeft = 50;
      var rightPosRight = 35;
      var column = 1;
      var topPos = 15;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //loop through ones
      var rightPosLeft = 17;
      var rightPosRight = 3;
      var column = 1;
      var topPos = 15;
      var topModifier = 15;

      qhtml+= "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //then loop through ones
  }
  else if (q.topic_key == "num42"){ //place value grid 1000-9999
    let thousands = GenerateRandom(1,8);
    let hundreds = GenerateRandom(1,8);
    let tens = GenerateRandom(1,8);
    let ones = GenerateRandom(1,8);

    var correctAnswer = thousands*1000 + hundreds * 100 + tens*10 + ones;
    questionText= "What number is shown on in the place value grid?";

    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1000,9999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});

      qhtml = '<img src="' + GetImage("placetablethousandshundredsones") + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>';

      //then loop through thousands
      var rightPosLeft = 90;
      var rightPosRight = 80;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml+= "<div>";
      for (let x = 0; x < thousands; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1000token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";

      //then loop through hundreds
      var rightPosLeft = 65;
      var rightPosRight = 55;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml+= "<div>";
      for (let x = 0; x < hundreds; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("100token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //then loop through tens
      var rightPosLeft = 40;
      var rightPosRight = 30;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml+= "<div>";
      for (let x = 0; x < tens; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("10token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //loop through ones
      var rightPosLeft = 15;
      var rightPosRight = 5;
      var column = 1;
      var topPos = 20;
      var topModifier = 18;

      qhtml+= "<div>";
      for (let x = 0; x < ones; x++) {
        //swaps columns
        let rightPos = rightPosLeft;
        if (column == 2){
          rightPos = rightPosRight;
          column = 1;
        }else{
          column = 2;
        }
        qhtml += '<img src="' + GetImage("1token") + '"' + "style='position:absolute ; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'

        if (column == 1){
          topPos += topModifier;
        }
      }
      qhtml+="</div>";
      //then loop through ones
  }
  else if (q.topic_key == "num56"){//4 digit number from a sum
    let thousands = GenerateRandom(1,9);
    let hundreds = GenerateRandom(1,9);
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);
    var correctAnswer = thousands * 1000 + hundreds*100 + tens*10 + ones;
    questionText= thousands + "x1000 + " + hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(1000,9999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
    
  }
  else if (q.topic_key == "num47"){//6 digit number from a sum
    let hundredthousands = GenerateRandom(1,9);
    let tenthousands = GenerateRandom(1,9);
    let thousands = GenerateRandom(1,9);
    let hundreds = GenerateRandom(1,9);
    let tens = GenerateRandom(1,9);
    let ones = GenerateRandom(1,9);
    var correctAnswer = hundredthousands * 100000 + tenthousands*10000 + thousands * 1000 + hundreds*100 + tens*10 + ones;
    questionText= hundredthousands + "x100,000 + " + tenthousands + "x10,000 + " + thousands + "x1000 + " + hundreds + "x100 + " + tens + "x10 + " + ones + " = ?";
    
    var usedAnswers = [];
    usedAnswers.push(correctAnswer);
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = GenerateUniqueRandom(100000,999999,usedAnswers);
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
    
  }
  else if (q.topic_key != "num36" && q.topic_key != "num37" && q.topic_key != "num38") {
    //One or two base numbers to shape the rest of the generation
    var randomNumbers = [];
    if (qKeys.includes(q.question_key))
      randomNumbers = parseFormula(generator[qKeys.indexOf(q.question_key)], [0, 0]).toString().split('|');

    //Fills in the question text complete with generated values
    var questionText = parseFormula(q.line_1, randomNumbers);
    if (q.line_2 !== "" && q.line_2 !== undefined)
      questionText += ": " + parseFormula(q.line_2, randomNumbers);

    //Creates an array of answers and fills in the correct answer
    var questionAnswers = [];
    var correctAnswer = parseFormula(q.correct_answer, randomNumbers).toString();
    questionAnswers.push({ correct: true, value: correctAnswer });

    //Fills in 2-3 wrong answers
    questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_1, randomNumbers, questionAnswers).toString() });
    questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_2, randomNumbers, questionAnswers).toString() });
    if (q.wrong_answer_3 !== undefined && q.wrong_answer_3 !== "")
      questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_3, randomNumbers, questionAnswers).toString() });
  }else if (q.topic_key == "num36"){
    var num1 = GenerateRandom(1,9)*100;
    var num2 = GenerateRandom(1,9)*10;
    var num3 = GenerateRandom(1,9);
    var questionText = "What is the missing number?";
    questionText+= ": " + num1 + "+ _ +" + num3.toString() + " = " + (num1+num2+num3);
    correctAnswer = num2;
    var usedAnswers = [];
    var questionAnswers = [];
    usedAnswers.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      var wrong = GenerateUniqueRandom(10,90,usedAnswers);
      usedAnswers.push(wrong);
      questionAnswers.push({correct: false, value: wrong});
    }
    questionAnswers.push({correct: true, value: correctAnswer});
  } else if (q.topic_key == "num37"){
    var mult10 = [10,100,1000];
    var multby1 = GenerateRandom(0,2);
    var multby2 = GenerateRandom(multby1,2);
    var num1 = GenerateRandom(1,10)*mult10[multby2];
    var num2 = mult10[multby1];
    var correctAnswer = num1/num2;
    var questionText = num1 + " ÷ " + num2 + " =";
    var wrongInt = num1 / mult10[multby2];

    var usedAnswers = [];
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = wrongInt*10;
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer})
  }else if (q.topic_key == "num38"){
    var mult10 = [10,100,1000];
    var multby1 = GenerateRandom(0,2);
    var n1 = GenerateRandom(1,99);
    var num1 = n1/100;
    var num2 = mult10[GenerateRandom(0,3)];
    var correctAnswer = num1 / num2;


    var questionText = num1 + " ÷ " + num2 + " =";

    var usedAnswers = [];
    var questionAnswers = [];
    num1 = num1 * num2;
    for (let i = 0; i < 3; i++) {
      num1 = num1/10;
      num1 = parseFloat(num1.toFixed(12));
      usedAnswers.push(num1);
      console.log(num1);
      questionAnswers.push({correct: false, value: num1.toString()});
    }
    correctAnswer = parseFloat(correctAnswer.toFixed(12));
    questionAnswers.push({correct: true, value: correctAnswer.toString()})
  }

  //Shuffles the answer array
  shuffleArray(questionAnswers);

  //Creates object to return
  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    correct: correctAnswer,
    topic_id: q.topic_id
  };

  return questionObj;
}

export default function Multiplayer({ ...props }) {
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([,]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [qImage, setQImage] = useState("");
  const [qHTML, setQuestionHTML] = useState("");

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Called on click
  async function checkResult(value, callback)
  {
    var isCorrect = true;
    if (value)
    {
      //correct answer
      if (currQuestion.correct === value.value)
      {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);
        if (multiplier != 0 && multiplier != undefined)
        props.SubmitScore(multiplier * 10);


        if (combo < 99)
        {
          setCombo(combo + 1);
        }
        if (combo > maxCombo)
        {
          setMaxCombo(combo);
        }
        newQuestion();
      } 
      //incorrect answer
      else
      {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10)
        {
          setScore(score - 10);
          props.SubmitScore(-10)
        } else
        {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
        //newQuestion();

    }
  }

  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var difficulty = Math.floor(Math.random() * questions.length);
    var questionNum = Math.floor(Math.random() * questions[difficulty].length)
    currQuestion = GenQuestion(questions[difficulty][questionNum]);;
    console.log(questions[difficulty][questionNum])
    console.log(currQuestion);
    setCurrentQuestion(currQuestion);
    return currQuestion;
  }

  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions)
      setCurrentQuestion(newQuestion())
    }
  }, [questions]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = "combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/"+imageName)
        return (require("../../assets/NumberAndPlace/Animation/"+imageName))
}


  return (
    <PracticeGame
    parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      getplace={() => GetPlace()}
    >
       <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
      <Body>
        <FormContent style={{ right: "100px", top: "0px", width: "200px", height: "50%" }}>
          <br></br>
          {GetListOfPositions()}
        </FormContent>
        <div>{currQuestion !== undefined ? (


          <Container>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Question
                type="text"
                disabled
                javaScriptEnabled={true}
                //I don't know if this does anything
                value={
                  currQuestion.question !== undefined
                    ? <div dangerouslySetInnerHTML={((currQuestion.question.replace("$", "?")))} />
                    : ""
                }
              >
                <div dangerouslySetInnerHTML={{ __html: (currQuestion.question) }} />
              </Question>
            </div>
            <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                      {(currentQuestion.image != "" && currentQuestion.image != undefined && currentQuestion.questionHTML == "") ? (
                        <img src={qImage}></img>
                      ) : (
                          <div></div>
                        )}

                        {currentQuestion.questionHTML != "" ? (
                        <DynamicStyle >
                          <div dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}
                        </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              {showColouredFeedback == false && currQuestion.answers !== undefined &&
                currQuestion.answers.map(answer => (
                  <Button
                    value={<div dangerouslySetInnerHTML={answer.value} />}
                    style={{ flex: 1, margin: "20px" }}
                    onClick={() => checkResult(answer, true)}
                  >
                    <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                  </Button>
                ))}

              {showColouredFeedback == true && currQuestion.answers !== undefined &&
                currQuestion.answers.map(answer => (
                  <Button
                    value={<div dangerouslySetInnerHTML={answer.value} />}
                    style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                  >
                    <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                  </Button>
                ))}
            </div>
          </Container>

        ) : <h1>help</h1>}
        </div>
        <Combo>
          <span style={{ fontSize: "50px" }}>{combo}</span>
          <span style={{ fontSize: "20px" }}>COMBO</span>
        </Combo>
      </Body>
      </div>
    </PracticeGame>
  );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url();
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;

const Question = styled.div`
  background: #E9E9E9;
  user-select: none;
  width: 40em;
  line-height: 35px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 20px 0px 20px;
  `;

const Button = styled.div`
        text-align: center;
        width: 5em;
        line-height: 35px;
        font-size: 3em;
  padding: 35px 0px 35px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

      const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
        position: realtive;
      top: 35%;
      //left: -15%;
      //width: 100%
      //text-align: center
      font-size 2em;
      //50%
    `;

